import { AxiosError, AxiosInstance } from 'axios';
import { logout } from '../app-redux/actions/login.actions';
import { store } from '../app-redux/store';
export const ACTION_RESPONSE_ERROR_INTERCEPTOR = 'RESPONSE_INTERCEPTOR_REQUEST';
export interface ErrorMessageDTO {
  error_description?: string;
  timestamp: string;
  status: number;
  error: string;
  code: string;
  message: string;
  path: string;
}
const axiosResponseInterceptor = (error: AxiosError<ErrorMessageDTO>) => {
  const {
    dispatch
  } = store;
  if (error.response) {
    if (error.response.status === 401) {
      logout()(dispatch);
    }
    dispatch({
      type: ACTION_RESPONSE_ERROR_INTERCEPTOR,
      payload: error.response.data
    });
  } else {
    const customError = {
      timestamp: '',
      status: error.code,
      error: 'Unexpected error',
      code: null,
      message: error.message,
      path: ''
    };
    dispatch({
      type: ACTION_RESPONSE_ERROR_INTERCEPTOR,
      payload: customError
    });
  }
  return Promise.reject(error);
};
export const applyAxiosInterceptors = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(response => response, axiosResponseInterceptor);
  return axiosInstance;
};